import type { PlayerTitleOption } from "./types/types"

export const faqs = [
  {
    question: "What is ChessDrop?",
    answer:
      "ChessDrop is a free online service to record, view and analyze your chess games. It has a beautiful and easy-to-use UI, works great on desktop and mobile, and is accessible anywhere, anytime. It’s private by default, but lets you share your favorite games and event whenever you like!",
  },
  {
    question: "Are my games private? Can I share them?",
    answer:
      "All your games are private, in the sense that each game is assigned a link that includes a very long random set of characters. But you can choose to share that link with anyone you like! Most commonly, people will share games they like on Twitter or in a club WhatsApp group.",
  },
  {
    question: "Does ChessDrop include a chess engine for analysis?",
    answer:
      "Yes! ChessDrop includes a lightweight version of Stockfish for quick, single-depth analysis.",
  },
  {
    question: "Can I add variations and comments to my games and moves?",
    answer:
      "Yes! Once you have saved the actual game moves, you can then start adding and saving variations and move comments for analysis.",
  },
  {
    question: "Does ChessDrop also work on mobile devices?",
    answer:
      "ChessDrop is designed to work equally well in desktop or mobile browsers like Chrome or Safari. On the phone, you can turn ChessDrop into app by doing Share → Add to Home Screen in iOS, and similar on Android.",
  },
  {
    question: "Can I import and export my games?",
    answer:
      "Yes! You can import and export games in PGN format. Since ChessDrop is a free services, our online server resources are modest, and therefore we limit imports to 100 games at a time.",
  },
  {
    question: "Is it really free?",
    answer:
      "Currently ChessDrop is free, and it has been since it was first created in 2016! We may at some point in the future offer a premium subscription with additional features.",
  },
  {
    question: "What if I have a question or need help?",
    answer:
      "If you run into any issues or have any questions, just drop us an email at support@chessdrop.com",
  },
]

// Keep 4 games in this array
export const onePlaceGames = [
  {
    score: "1-0",
    players: "Lance Henderson - Abhijeet Gupta",
  },
  {
    score: "1-0",
    players: "Magnus Carlsen - Fabiano Caruana",
  },
  {
    score: "1-0",
    players: "Paul Morphy - Jacques Chamouillet",
  },
  {
    score: "½-½",
    players: "Susan Polgar - Anatoly Karpov",
  },
]

// Keep 3 games in this array
export const eventGames = [
  {
    score: "½-½",
    players: "Maxime Vachier-Lagrave - Fabiano Caruana",
  },
  {
    score: "0-1",
    players: "Ding Liren - Wang Hao",
  },
  {
    score: "1-0",
    players: "Ian Nepomniachtchi - Kirill Alekseenko",
  },
]

export const variationsGame = {
  score: "1-0",
  players: "Lance Henderson - Gharibyan Mamikon",
}

export const shareGame = {
  score: "1-0",
  players: "Lance Henderson - Abhijeet Gupta",
}

export const startFen =
  "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1"

export const viewport = { once: true, margin: "0px 0px -300px" }

export const supportEmail = "support@chessdrop.com"

export const emptyFen = "8/8/8/8/8/8/8/8 w - - 0 1"

export const titleOptions: PlayerTitleOption[] = [
  "",
  "WCM",
  "CM",
  "WIM",
  "IM",
  "WFM",
  "FM",
  "WGM",
  "GM",
]
